import { GeneralInfoState } from "@reducers/types/HRM/general-info-state";

import {
  GET_GENERAL_INFO,
  CREATE_GENERAL_INFO,
  UPDATE_GENERAL_INFO,
} from "@actions/HRM/employee/types";
import { GeneralInfoActions } from "@actions/HRM/employee/general-info-actions";

import {
  getInitialState,
  getRequestingState,
  getSuccessState,
  getFailedState,
} from "@utils/store";

const initialState: GeneralInfoState = { ...getInitialState() };

const GeneralInfosReducer = (
  state = initialState,
  action: GeneralInfoActions,
): GeneralInfoState => {
  switch (action.type) {
    // CREATE
    case GET_GENERAL_INFO.GET_GENERAL_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state.data,
          data: null,
          getGeneralInfoRequestOngoing: true,
          getGeneralInfoSuccess: false,
          getGeneralInfoFailed: false,
          updateGeneralInfoRequestOngoing: false,
          updateGeneralInfoSuccess: false,
          updateGeneralInfoFailed: false,
          createGeneralInfoRequestOngoing: false,
          createGeneralInfoSuccess: false,
          createGeneralInfoFailed: false,
        }),
      };

    case GET_GENERAL_INFO.GET_GENERAL_INFO_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({
          ...state.data,
          data: payload.data,
          getGeneralInfoRequestOngoing: false,
          getGeneralInfoSuccess: true,
          getGeneralInfoFailed: false,
        }),
      };
    }

    case GET_GENERAL_INFO.GET_GENERAL_INFO_FAILED:
      return {
        ...getFailedState({
          ...state.data,
          data: null,
          getGeneralInfoRequestOngoing: false,
          getGeneralInfoSuccess: false,
          getGeneralInfoFailed: true,
        }),
      };

    //CREATE
    case CREATE_GENERAL_INFO.CREATE_GENERAL_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state.data,
          createGeneralInfoRequestOngoing: true,
          createGeneralInfoSuccess: false,
          createGeneralInfoFailed: false,
          updateGeneralInfoRequestOngoing: false,
          updateGeneralInfoSuccess: false,
          updateGeneralInfoFailed: false,
        }),
      };

    case CREATE_GENERAL_INFO.CREATE_GENERAL_INFO_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({
          ...state.data,
          data: payload.data,
          createGeneralInfoRequestOngoing: false,
          createGeneralInfoSuccess: true,
          createGeneralInfoFailed: false,
        }),
      };
    }

    case CREATE_GENERAL_INFO.CREATE_GENERAL_INFO_FAILED:
      const { payload } = action as any;
      return {
        ...getFailedState({
          ...state.data,
          createGeneralInfoRequestOngoing: false,
          createGeneralInfoSuccess: false,
          createGeneralInfoFailed: true,
          createGeneralInfoError: payload.err,
        }),
      };

    //UPDATE
    case UPDATE_GENERAL_INFO.UPDATE_GENERAL_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state.data,
          updateGeneralInfoRequestOngoing: true,
          updateGeneralInfoSuccess: false,
          updateGeneralInfoFailed: false,
          createGeneralInfoRequestOngoing: false,
          createGeneralInfoSuccess: false,
          createGeneralInfoFailed: false,
        }),
      };

    case UPDATE_GENERAL_INFO.UPDATE_GENERAL_INFO_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({
          ...state.data,
          data: payload.data,
          updateGeneralInfoRequestOngoing: false,
          updateGeneralInfoSuccess: true,
          updateGeneralInfoFailed: false,
        }),
      };
    }

    case UPDATE_GENERAL_INFO.UPDATE_GENERAL_INFO_FAILED: {
      const { payload } = action as any;
      return {
        ...getFailedState({
          ...state.data,
          data: {
            ...state,
            ...payload.data,
          },
          updateGeneralInfoRequestOngoing: false,
          updateGeneralInfoSuccess: false,
          updateGeneralInfoFailed: true,
        }),
      };
    }

    default:
      return state;
  }
};

export default GeneralInfosReducer;
